<template>
  <div @touchmove.prevent>
    <div class="loading-mask"></div>
    <div class="loading-text" v-show="showText"></div>
    <div class="loading-container">
      <div class="loading-spinner">
        <div class="loading">
          <div :class="{'text-color': showText}"></div>
        </div>
      </div>
      <div class="text" v-show="showText">请稍等</div>
    </div>
  </div>
</template>

<script>
	export default {
		name: 'await-loading',
		props: {
			showText: {
				type: Boolean,
				default: false
			}
		},
		data () {
			return {}
		},
		mounted () {
		},
		computed: {},
		watch: {},
		components: {},
		methods: {}
	}
</script>

<style lang="scss" scoped>
  @keyframes loading {
    0% {
      transform: translate(-50%, -50%) rotate(0deg);
    }
    100% {
      transform: translate(-50%, -50%) rotate(360deg);
    }
  }
  .loading-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 90px;
    position: fixed;
    top: 50%;
    left: 0;
    transform: translateY(-50%);
    z-index: 2103;
    .text {
      margin-top: 10px;
      color: #ffffff;
    }
  }
  .loading-mask {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: transparent;
    z-index: 2101;
  }
  .loading-text {
    width: 90px;
    height: 90px;
    border-radius: 4px;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translateX(-50%) translateY(-50%);
    background-color: rgba($color: #000000, $alpha: 0.8);
    z-index: 2102;
  }
  .loading div {
    position: absolute;
    width: 22px;
    height: 22px;
    border: 5px solid #dedede;
    border-top-color: transparent;
    border-radius: 50%;
  }
  .text-color {
    border: 5px solid #ffffff !important;
    border-top-color: transparent !important;
  }
  .loading div {
    animation: loading 1s linear infinite;
    top: 18px;
    left: 18px;
  }
  .loading-spinner {
    width: 36px;
    height: 36px;
    display: inline-block;
    overflow: hidden;
    background: rgba(255, 255, 255, 0);
  }
  .loading {
    width: 100%;
    height: 100%;
    position: relative;
    transform: translateZ(0) scale(1);
    backface-visibility: hidden;
    transform-origin: 0 0; /* see note above */
  }
  .loading div {
    box-sizing: content-box;
  }
  /* generated by https://loading.io/ */
</style>
